import React from 'react';

import IconWithTitleDescription from '@/shared/components/atoms/IconWithTItleDescription';
import { IIconWithTitleDescriptionProps } from '@/shared/components/atoms/IconWithTItleDescription/IconWithTitleDescription';

interface IProps {
  data: IIconWithTitleDescriptionProps[];
}
const ApprovalCardDetails = ({ data }: IProps) => {
  return (
    <div className='flex items-center justify-between rounded-2xl bg-background-neutral-99 p-16'>
      {data.map((item, index) => (
        <IconWithTitleDescription key={index} item={item} />
      ))}
    </div>
  );
};
export default ApprovalCardDetails;
